export const truncateStringEllipsis = (stringValue = '', stringLength = 0) =>
  stringValue.length > stringLength ? `${stringValue.substr(0, stringLength)}...` : stringValue;

export const findStudentFullName = student => {
  if (!student) return '';

  return `${student.lastName}, ${student.firstName}`;
};
